import { isRecent } from "@/lib/catalog";

interface NewBadgeProps {
  createdAt?: string | null;
  days?: number;
  className?: string;
}

/**
 * Etiqueta flotante "Nuevo" basada en la fecha de creación.
 * Se oculta automáticamente pasados los 15 días (por defecto).
 */
export default function NewBadge({
  createdAt,
  days = 15,
  className = "",
}: NewBadgeProps) {
  if (!isRecent(createdAt, days)) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-white shadow-soft ${className}`}
    >
      <i className="ri-sparkling-2-line text-xs"></i>
      Nuevo
    </span>
  );
}